"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findTabbableDescendants = exports.tabbable = exports.focusable = exports.FOCUS_SELECTOR = void 0;
var TABBABLE_NODES = /input|select|textarea|button|object/;
exports.FOCUS_SELECTOR = 'a, input, select, textarea, button, object, [tabindex]';
function hidden(element) {
    if (process.env.NODE_ENV === 'test') {
        return false;
    }
    return ((element.offsetWidth <= 0 && element.offsetHeight <= 0) || element.style.display === 'none');
}
function visible(element) {
    var parentElement = element;
    while (parentElement) {
        if (parentElement === document.body) {
            break;
        }
        if (hidden(parentElement)) {
            return false;
        }
        parentElement = parentElement.parentNode;
    }
    return true;
}
function getElementTabIndex(element) {
    var tabIndex = element.getAttribute('tabindex');
    if (tabIndex === null) {
        tabIndex = undefined;
    }
    return parseInt(tabIndex, 10);
}
function focusable(element) {
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
    var res = 
    // @ts-ignore
    (TABBABLE_NODES.test(nodeName) && !element.disabled) ||
        (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
}
exports.focusable = focusable;
function tabbable(element) {
    var tabIndex = getElementTabIndex(element);
    var isTabIndexNaN = Number.isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
exports.tabbable = tabbable;
function findTabbableDescendants(element) {
    return Array.from(element.querySelectorAll(exports.FOCUS_SELECTOR)).filter(tabbable);
}
exports.findTabbableDescendants = findTabbableDescendants;
